import React, { useRef, useEffect, useState } from "react";
import {
  RootWrapper,
  HeaderStyled,
  BodyRootWrapper,
  BodyWrapper,
  BodyStyled,
} from "../../theme";
import { Logo } from "../shared/logo";
import Footer from "../shared/footer";
import { SwitchLanguage } from "../shared/switchLanguage";

export const LayoutLogin = (props) => {
  const boxRef = useRef();
  const [floatFooter, setFloatFooter] = useState(true);
  /* Update chart width and height */
  useEffect(() => {
    let windowHeight = window.innerHeight;
    let boxHeight = boxRef.current.offsetHeight - 121;
    setFloatFooter(windowHeight > boxHeight ? true : false);
  }, []);
  return (
    <RootWrapper>
      <HeaderStyled>
        <Logo linkTo="/" />
        <SwitchLanguage login />
      </HeaderStyled>
      <BodyRootWrapper ref={boxRef} floatFooter={floatFooter} login>
        <BodyWrapper login>
          <BodyStyled login>{props.children}</BodyStyled>
          <Footer login />
        </BodyWrapper>
      </BodyRootWrapper>
    </RootWrapper>
  );
};
